import React from 'react';
import { connect } from 'react-redux';
import DropSimple from '../DropSimple';
import * as DesignerState from '../../../../state/reducer/designer/designer';
import Console from '../../../../lib/debug';

class BlockLeaderboard extends React.Component {
    arrowRenderer() {
        return <span className="mdi mdi-chevron-down" />;
    }
    toggleLeaderboard(ev) {
        let block = this.props.block;
        let dispatch = this.props.dispatch;
        DesignerState.toggleLeaderboard(dispatch, block, ev.target.checked);
    }
    updateLeaderboardValue(value) {
        let block = this.props.block;
        let dispatch = this.props.dispatch;
        DesignerState.updateBlock(dispatch, block, 'redzone_type', value.id);
    }
    render() {
        Console.render('designer.BlockLeaderboard');
        let block = this.props.block;
        let placeholder = 'Add Leaderboard?';

        if (block.plain_text === 1) {
            placeholder = 'For Completion';
        }

        let leaderboard = (
            <DropSimple
                value={block.redzone_type}
                valueKey="id"
                labelKey="title"
                className="select-50"
                placeholder={placeholder}
                clearable={false}
                autoBlur={true}
                onChange={this.updateLeaderboardValue.bind(this)}
                options={this.props.leaderboardTypesRef}
                arrowRenderer={this.arrowRenderer.bind(this)}
            />
        );

        return (
            <div className="leaderboard">
                <label>Results</label>
                {leaderboard}
            </div>
        );
    }
}

let mapStatetoLeaderboardProps = function(state, ownProps) {
    return {
        ...ownProps,
        leaderboardTypesRef: state.library.leaderboardTypesRef.resultsTypes
    };
};

export default connect(mapStatetoLeaderboardProps)(BlockLeaderboard);



// WEBPACK FOOTER //
// ./src/view/designer/components/Block/BlockLeaderboard.jsx